import axios from "axios";

export default class AuthAPI {
  // Fetch an unique id for the current user
  static async getClientID() {
    return axios({
      method: "GET",
      headers: { "app-id": "GrowthCloud" },
      url: `${window.GC_API_URL}/auth/get-client-id`,
      withCredentials: true,
    });
  }

  static async saveRefreshToken(token: string, refreshToken: string) {
    return axios({
      method: "POST",
      url: `${window.GC_API_URL}/auth/save-refresh-token`,
      headers: { Authorization: "Bearer " + token, "app-id": "GrowthCloud" },
      data: { refreshToken },
      withCredentials: true,
    });
  }

  // Attempts to authenticate a user using the local provider (Email and Password)
  static async authenticateLocal(email: string, password: string) {
    await this.getClientID();

    return axios({
      method: "GET",
      url: window.GC_API_URL + `/auth/providers/local`,
      withCredentials: true,
      headers: {
        "app-id": "GrowthCloud",
      },
      auth: {
        username: email,
        password,
      },
    });
  }
}
